import { styled } from "@mui/material";
import { ColorSAP } from "../../ontego-ui";

const Styled = {};

Styled.Container = styled("div")(({ showShadow }) => ({
  position: "fixed",
  top: 88,
  left: 0,
  width: "100%",
  backgroundColor: ColorSAP.neutral[0],
  boxShadow: showShadow ? "0px 2px 4px 0px rgba(0, 0, 0, 0.08)" : "none",
  transition: "box-shadow 0.3s ease",
  padding: "16px 0",
  zIndex: 1200,
  display: "flex",
  justifyContent: "center",
  boxSizing: "border-box",
}));

Styled.Content = styled("div")(() => ({
  width: 1200,
  maxWidth: 1200,
  height: 38,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "@media (max-width: 1280px)": {
    maxWidth: "calc(100% - 80px)",
  },
}));

Styled.ChipsContainer = styled("div")(() => ({
  display: "flex",
  gap: 8,
  alignItems: "center",
  flexShrink: 0,
  paddingRight: "32px"
}));

export default Styled;
